import clsx from 'clsx'
import Loading from '@Components/Loading/Loading'
import { useRef } from 'react'
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline'
import DownloadIcon from '@mui/icons-material/Download'
import { CommonService } from '@Services/common.service'

interface IUploadFiles {
    className?: string
    isLoading?: boolean
    id?: string
    disabled?: boolean
    fileChanged?: (params: any) => void
    removeAction?: () => void
    remove?: boolean
    filename?: string
    fileUrl?: string
    style?: any
    label?: string
}
function UploadFiles(props: IUploadFiles) {
    const {
        className,
        isLoading = false,
        id = 'upload-files',
        disabled = false,
        fileChanged,
        removeAction,
        remove = false,
        filename = '',
        fileUrl = '',
        style,
        label,
    } = props

    // const [filename, setFilename] = useState('')
    const fileInput = useRef<any>()

    // functions section
    function onChange(e: any) {
        e.preventDefault()

        if (!e || !e.target || !e.target.files || e.target.files.length === 0) {
            return
        }

        const { name } = e.target.files[0]
        const lastDot = name.lastIndexOf('.')

        const trimmedName = name.substring(0, lastDot)
        const ext = name.substring(lastDot + 1)

        // setFilename(trimmedName)
        let files
        if (e.dataTransfer) {
            files = e.dataTransfer.files
        } else if (e.target) {
            files = e.target.files
        }
        const reader = new FileReader()
        reader.onload = () => {
            if (fileChanged)
                fileChanged({
                    file: reader.result as any,
                    filename: trimmedName,
                    extension: ext,
                })
        }
        reader.readAsDataURL(files[0])
        // clear input file
        e.target.value = []
    }

    // handle remove action
    const handleRemoveFile = (e: any) => {
        e.stopPropagation()
        e.preventDefault()
        // setFilename('')
        if (removeAction) removeAction()
    }

    const onDownloadFile = (e: any) => {
        // e.stopPropagation()
        // e.preventDefault()
        CommonService.downloadByUrl(e?.url, e?.name)
    }

    return (
        <div
            className={clsx(className, 'upload-file position-relative')}
            style={style}
        >
            <Loading isLoading={isLoading} />
            {filename && remove ? (
                <RemoveCircleOutlineIcon
                    className="remove-action"
                    onClick={handleRemoveFile}
                />
            ) : null}
            {fileUrl ? (
                <DownloadIcon
                    className="download-action"
                    onClick={() =>
                        onDownloadFile({ url: fileUrl, name: filename })
                    }
                />
            ) : null}
            <div>
                <img
                    src={
                        require('../../assets/images/icons/file-icon.svg')
                            .default
                    }
                    alt=""
                />
                <p className="d-block gray-text m-0 mt-1 filename">
                    {filename || label || 'Upload FFL paperwork'}
                </p>
            </div>
            <label
                htmlFor={id}
                id="input_file_label"
                className={clsx(
                    !disabled ? 'cursor-pointer' : 'cursor-not-allowed'
                )}
                style={{
                    // cursor: `${!disabled && 'pointer'}`,
                    position: 'absolute',
                    width: '100%',
                    height: '100%',
                    margin: 0,
                }}
            >
                <input
                    type="file"
                    onChange={onChange}
                    hidden
                    ref={fileInput}
                    accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, text/plain, .pdf,image/png, image/jpeg"
                    id={id}
                    disabled={disabled}
                />
            </label>
        </div>
    )
}

export default UploadFiles
